import React, { Component, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import * as airActions from "../../redux/actions/airAction";
import * as notificationActions from "../../redux/actions/notificationAction";
import AirContainer from "../../containers/Air/index"
import history from "../../utilities/history";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionMenuItem";

const NotificationModal = (props) => {
  const dispatch = useDispatch();
  const airReducer = useSelector((state) => state.airReducer);
  const userAuthReducer = useSelector((state) => state.userAuthReducer);
  const notificationReducer = useSelector((state) => state.notification);

  const airAction = bindActionCreators(airActions, dispatch);
  const notificationAction = bindActionCreators(notificationActions, dispatch);

  const [acmdCount, setAcmdCount] = useState(0);
  const [stdCount, setStdCount] = useState(0);
  const [airCount, setAirCount] = useState(0);
  const [ccmCount, setCCMCount] = useState(0);

  useEffect(() => {
    if (userAuthReducer.userPermissions && userAuthReducer.userPermissions.length > 0) {
      const userPermissionSTD = userAuthReducer.userPermissions.find(x => x.authModule == PERMISSON_MODULES.STD_FORM)
      const userPermissionAIR = userAuthReducer.userPermissions.find(x => x.authModule == PERMISSON_MODULES.AIR_FORM)
      const userPermissionAcc = userAuthReducer.userPermissions.find(x => x.authModule == PERMISSON_MODULES.ACMD_FORM)
      const userPermissionCCM = userAuthReducer.userPermissions.find(x => x.authModule == PERMISSON_MODULES.CCM_FORM)
      if (userPermissionSTD && userPermissionAIR && userPermissionAcc && userPermissionCCM &&
        userPermissionSTD[PERMISSION_TYPE.VIEW] && userPermissionAIR[PERMISSION_TYPE.VIEW] &&
        userPermissionAcc[PERMISSION_TYPE.VIEW] && userPermissionCCM[PERMISSION_TYPE.VIEW])
        if (props && props.managersDetails && props.managersDetails.managerId) {
          notificationAction.getAllPendingApplications(props.managersDetails.managerId);
        }
    }
    //airAction.getPendingAirApplications(props.managersDetails.managerId);
  }, [userAuthReducer.userPermissions]);
  useEffect(() => {
    //airAction.getPendingAirApplications(props.managersDetails.managerId);
    let allPendingApplications = notificationReducer.allPendingApplications;
    let acmdcount = 0;
    let stdcount = 0;
    let aircount = 0;
    let ccmcount = 0;
    setStdCount(0);
    setAcmdCount(0);
    setAirCount(0);
    setCCMCount(0);
    allPendingApplications.map((pendingApplication, index) => {
      // pendingApplication.applicationType && pendingApplication.applicationType == "ACMD" ?  : pendingApplication.applicationType && pendingApplication.applicationType == "STD" ? setStdCount(stdcount = stdcount + 1) : setAirCount(aircount = aircount + 1);
      if (pendingApplication.applicationType)
        switch (pendingApplication.applicationType) {
          case "ACMD":
            setAcmdCount(acmdcount = acmdcount + 1)
            break;
          case "STD":
            setStdCount(stdcount = stdcount + 1)
            break;
          case "AIR":
            setAirCount(aircount = aircount + 1)
            break;
          case "CCM":
            setCCMCount(ccmcount = ccmcount + 1)
            break;
        }
    })
  }, [notificationReducer.allPendingApplications]);

  return (
    <>
      {props.notification.isNotificationPopupShown &&
        <div className={props.notification.isNotificationPopupShown ? "modal right fade show md" : "modal right fade md"} id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="myModalLabel2">{props.context.t("DASHBOARD.Notifications.text")}</h4>
                <button onClick={() => { props.onNotificationIconClick(false) }} type="button" className="close noti" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body notification-modal">
                <label>{props.context.t("DASHBOARD.Pending.Application.text")}</label>
                <div className="outer-box">
                  <ShowForPermission module={PERMISSON_MODULES.STD_FORM} permission={PERMISSION_TYPE.VIEW}>
                    <div className="inner-box">
                      <div className="content">
                        <span className="std" onClick={() => {
                          props.onNotificationIconClick(false);
                          history.push(`/refURL?URL=/std`)
                        }}>{props.context.t("STD-Hamburger.text")}</span>
                        <span className="badge badge-warning">{stdCount}</span>
                      </div>
                    </div>
                  </ShowForPermission>
                  <ShowForPermission module={PERMISSON_MODULES.AIR_FORM} permission={PERMISSION_TYPE.VIEW}>
                    <div className="inner-box" onClick={() => {
                      props.onNotificationIconClick(false)
                      history.push(`/refURL?URL=/air`)
                    }}>
                      <div className="content">
                        <span className="air">{props.context.t("STD-Dashboard.label.heading.title-4")}</span>
                        <span className="badge badge-primary">{airCount}</span>
                      </div>
                    </div>
                  </ShowForPermission>
                  <ShowForPermission module={PERMISSON_MODULES.ACMD_FORM} permission={PERMISSION_TYPE.VIEW}>
                    <div className="inner-box">
                      <div className="content" onClick={() => {
                        props.onNotificationIconClick(false)
                        history.push(`/refURL?URL=/accomodation`)
                      }}>
                        <span className="accomodation">{props.context.t("STD-Dashboard.label.heading.title-5")}</span>
                        <span className="badge badge-success">{acmdCount}</span>
                      </div>
                    </div>
                  </ShowForPermission>
                  <ShowForPermission module={PERMISSON_MODULES.CCM_FORM} permission={PERMISSION_TYPE.VIEW}>
                    <div className="inner-box">
                      <div className="content" onClick={() => {
                        props.onNotificationIconClick(false)
                        history.push(`/refURL?URL=/ccm`)
                      }}>
                        <span className="ccm">{props.context.t("CCM-Dashboard.label.heading.title")}</span>
                        <span className="badge badge-info">{ccmCount}</span>
                      </div>
                    </div>
                  </ShowForPermission>
                </div>
              </div>
            </div>
          </div>
          <div
            className="User-Profile-overlay"
            onClick={() => { props.onNotificationIconClick(false) }}
          ></div>
        </div>}
    </>
  );
}


export default NotificationModal

